import React from 'react'

import Button from 'components/Form/Button'
import { StateDescription, StateRoot, StateTitle } from './styled'

export default function CompetitiveIntelligenceState({ actionLabel, description, onAction, title, urgent }) {
    return (
        <StateRoot role={urgent ? 'alert' : 'status'}>
            <StateTitle>{title}</StateTitle>
            <StateDescription>{description}</StateDescription>
            {onAction ? (
                <Button color="blue" nospace outline width="fit-content" onClick={onAction}>{actionLabel}</Button>
            ) : null}
        </StateRoot>
    )
}
